export const resellerStatuses = [
  {
    name: 'active',
    displayName: 'Active',
    disabled: false,
  },
  {
    name: 'blocked',
    displayName: 'Blocked',
    disabled: false,
  },
  {
    name: 'deleted',
    displayName: 'Deleted',
    disabled: false,
  },
]
